import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ButtonMenu, MenuItem, Text } from "designSystem/index";
import ListWithSubheader, { ListSection } from "designSystem/components/list/ListWithSubheader";
import React, { ReactNode } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	const createSection = (sectionName: string): ReactNode => {
		return (
			<>
				{items.filter((x) => x.group === sectionName)
					.map((item) =>
						<MenuItem key={item.id} text={item.name} />)}
			</>
		);
	};

	const sections: ListSection[] = [
		{
			sectionName: "CA",
			sectionBody: createSection("CA"),
		},
		{
			sectionName: "WA",
			sectionBody: createSection("WA"),
		},
		{
			sectionName: "AZ",
			sectionBody: createSection("AZ"),
		},
		{
			sectionName: "CA2",
			sectionBody: createSection("CA"),
		},
		{
			sectionName: "WA2",
			sectionBody: createSection("WA"),
		},
	];

	return (
		<CssColumnGrid columns={2}>
			<ButtonMenu
				design='primary'
				endIcon={
					<ArrowDropDownIcon />
				}
				label={
					<Text text="ButtonMenu" />
				}
			>
				<ListWithSubheader sections={sections} />
			</ButtonMenu>
		</CssColumnGrid>
	);
};